import { Route, Switch } from "wouter";
import { lazy, Suspense } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Home from "./pages/Home";

const TopicPage = lazy(() => import("./pages/TopicPage"));
const ArticlePage = lazy(() => import("./pages/ArticlePage"));
const About = lazy(() => import("./pages/About"));
const Subscribe = lazy(() => import("./pages/Subscribe"));
const Advertise = lazy(() => import("./pages/Advertise"));
const Contact = lazy(() => import("./pages/Contact"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function RouteLoading() {
  return <div className="min-h-screen bg-background" aria-live="polite" aria-label="Loading page" />;
}

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <>
      <AnalyticsTracker />
      <Suspense fallback={<RouteLoading />}>
        <Switch>
        {/* Protected editorial workspace routes must precede generic article routes. */}
        <Route path={"/admin"} component={Admin} />
        <Route path={"/admin/articles/new"} component={Admin} />
        <Route path={"/admin/articles"} component={Admin} />
        <Route path={"/admin/subscribers"} component={Admin} />
        <Route path={"/"} component={Home} />
        <Route path={"/about"} component={About} />
        <Route path={"/subscribe"} component={Subscribe} />
        <Route path={"/advertise"} component={Advertise} />
        <Route path={"/contact"} component={Contact} />
        {/* Article routes (/:section/:article) must precede topic routes */}
        <Route path={"/:section/:article"} component={ArticlePage} />
        {/* Topic pages — one reusable template for every section */}
        <Route path={"/:section"} component={TopicPage} />
        <Route path={"/404"} component={NotFound} />
        {/* Final fallback route */}
        <Route component={NotFound} />
        </Switch>
      </Suspense>
    </>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="dark"
        // switchable
      >
        <Router />
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
